import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = { key: 6 }

import {saveRecharge, searchClinic} from "@/api/clinic";
import {reactive, ref, UnwrapRef, onMounted, watch, VNode, h} from "vue";
import AddHospitalVue from "../hospital/addHospital.vue";
import STATUS from "@/components/model/enum"
import areaJson from "@/assets/area.json";
import {useRoute, useRouter} from "vue-router";
import {LocalStorageService} from "@/components/ts/localStorage";
import {USER_INFO} from "@/store/mutation-types";
import {message} from "ant-design-vue";
import {ValidateErrorEntity} from "ant-design-vue/es/form/interface";
import {copyToClip} from "@/utils/clip";
import mobileView from "@/components/view/mobileView.vue";
interface Data {
    loading: boolean;
    dataSource: any[];
    expand: boolean;
    addHospitalvisible: boolean;
    pagination: any,
    hospitalId: any,
    addHospitalloading: boolean,
    hospitalDetailVisible: boolean,
    type: string,
    license: string,
    isShowChildrenHospital: boolean
    //充值参数
    rechargeVisible: boolean;

}
interface ClinicRecharge {
    clinicId: string;
    rechargeFee: string;
    rechargeFrequency: number|undefined;
}
interface Options {
    options1: any;
    value1: any[];
    disabled: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Hospital',
  props: {
    type: {
        type: Number,
        default: 1
    },
    dentistId: {
        type: String,
        default: ""
    },
    parentId: {
        type: String,
        default: ""
    },
    license: {
        type: String,
        default: ""
    }
},
  setup(__props) {

const prop = __props;

const rechargeRef = ref();
const route = useRoute()

// import AddChildrenHospital from "./addChildrenHospital.vue";
const clinicRecharge = reactive({
    clinicId: "",
    rechargeFee: "",
    rechargeFrequency: '',
})


const columns = [
    {
        title: "医院名称",
        dataIndex: "shortName",
        key: "shortName",
    },
    {
        title: "省市区",
        dataIndex: "area",
        key: "area",
        width: "15%",
    },
    {
        title: "医院详细住址",
        dataIndex: "address",
        key: "address",
        width: "12%",
    },
    {
        title: "机构性质",
        dataIndex: "type",
        key: "type",
    },
    {
        title: "医院电话",
        dataIndex: "tel",
        key: "tel",
    },
    {
        title: "联系人",
        dataIndex: "contact",
        key: "contact",
    },
    {
        title: "联系人电话",
        dataIndex: "contactsPhone",
        key: "contactsPhone",
        width: 130,
        customRender: function({record}: any): VNode {
            return h(mobileView,
                {
                    title: '点击复制',
                    mobile: record.contact.mobile,
                    onClick: () => copyToClip(record.contact.mobile),
                },
                ()=>{return record.contact.mobile})
        },
    },
    {
        title: "联系人职位",
        dataIndex: "position",
        key: "position",
    },
    {
        title: "操作",
        dataIndex: "operation",
        width: '15%'
    },
];

const onScheduling = (id: number) => {
    router.push({
        path: '/dentist/team/scheduling',
        query: {
            relatedId: id,
            relateType: 15
        }
    })
}
const onFinish = (values: any) => {
    console.log("Received values of form: ", values);
    console.log("formState: ", formState);
    data.pagination.current = 1
    onSearch();
};
const formState = reactive({
    type: "",
    keyword: "",
    areaId: '',
    dentistId: '',
    parentId: ''
});

let data: UnwrapRef<Data> = reactive({
    loading: true,
    dataSource: [],
    expand: false,
    addHospitalvisible: false,
    pagination: {
        size: "large",
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"], //可选的页面显示条数
        showTotal: (total: string) => {
            return " 共" + total + "条";
        }, //展示每页第几条至第几条和总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showSizeChanger: true, //是否可以改变pageSize
    },
    hospitalId: 0,
    addHospitalloading: false,
    hospitalDetailVisible: false,
    type: 'add',
    license: '',
    isShowChildrenHospital: false,
    //充值参数
    rechargeVisible: false,
});

const options: UnwrapRef<Options> = reactive({
    options1: areaJson,
    value1: [],
    disabled: false,
});

const handleTableChange = (ipagination: any) => {
    data.pagination.pageSize = ipagination.pageSize;
    data.pagination.current = ipagination.current;
    onSearch();
};

function onSearch() {
    data.loading = true;
    searchClinic({
        page: {
            pageSize: data.pagination.pageSize,
            currPage: data.pagination.current,
        },
        keyword: formState.keyword,
        areaId: formState.areaId,
        dentistId: formState.dentistId,
        parentId: formState.parentId
    }).then((res: { records: number; data: any[] }) => {
        data.loading = false;
        data.dataSource = res ? res.data : [];
        data.pagination.total = res ? res.records : 0;
    });
}

const onEdit = async (key: any) => {
    console.log(key.id);
    data.hospitalId = key.id
    data.addHospitalvisible = true;
    data.type = 'update'
};

const onAddChildren = (key: any) => {
    console.log(">>", key);
    data.hospitalId = key.id + ''
    data.type = 'addChildren'
    data.license = key.license
    data.isShowChildrenHospital = true
    router.push({
        path: '/hospital/childrenHospital',
        query: {
            clinicId: key.id,
            type: 'addChildren',
            license: key.license
        }
    })
}

const addHandle = () => {
    console.log("新增医院");
    data.hospitalId = 0
    data.addHospitalvisible = true;
    data.type = 'add'
    if (formState.parentId) {
        data.type = 'addChildren'
        data.hospitalId = formState.parentId
    }
};
const onCancel = (show: boolean) => {
    console.log("取消", show);
    data.addHospitalloading = false;
    if (show) {
        hideModal()
    }
};
const hideModal = () => {
    console.log('关闭弹框');
    data.addHospitalvisible = false;
    onSearch();
}
const addHospitalRef = ref()
const onSubmit = () => {
    console.log("确认");
    data.addHospitalloading = true
    addHospitalRef.value.onSubmit()
}
const router = useRouter()
// 查看详情
const onHospitalDetail = (id: any) => {
    console.log('查看详情', id);
    data.hospitalDetailVisible = true
    router.push({
        path: '/hospital/hospitalInfo',
        query: {
            id
        }
    })
}

const handleChange = (value: string | any[]) => {
    console.log(value);
    formState.areaId = value ? value[value.length - 1] : "";
};
const rechargeRules = {
    rechargeFrequency: [
        {required: true, message: '请输入本次充值的拍照次数', trigger: 'blur'},
    ],
}

const showRecharge = (id: string)=>{
    data.rechargeVisible = true;
    clinicRecharge.clinicId = id;
}
const saveARecharge = () =>{
    rechargeRef.value
        .validate()
        .then(() => {
            saveRecharge(clinicRecharge).then((res: any)=>{
                rechargeRef.value.resetFields();
                message.success("保存成功！");
                data.rechargeVisible = false;
                onSearch();
            })
        })
        .catch((error: ValidateErrorEntity<ClinicRecharge>) => {
            console.log('error', error);
        });

}
const rechargeCancel = () =>{
    rechargeRef.value.resetFields();
    data.rechargeVisible = false
}


watch(
    () => route.query.clinicId,
    () => {
        location.reload();
    }
);

onMounted(() => {
    console.log(11111);
    formState.dentistId = prop.dentistId
    formState.parentId = prop.parentId
    data.hospitalId = prop.parentId
    data.license = prop.license
    onSearch();
})


return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _directive_btnPermission = _resolveDirective("btnPermission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.type == 1)
      ? (_openBlock(), _createBlock(_component_a_form, {
          key: 0,
          ref: "formRef",
          name: "advanced_search",
          class: "ant-advanced-search-form",
          model: formState,
          onFinish: onFinish
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: formState.keyword,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.keyword) = $event)),
                          placeholder: "关键字",
                          "allow-clear": ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_cascader, {
                          value: options.value1,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((options.value1) = $event)),
                          options: options.options1,
                          placeholder: "请选择地区",
                          changeOnSelect: "",
                          "field-names": { label: 'name', value: 'id' },
                          onChange: handleChange
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查询")
                      ]),
                      _: 1
                    }),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "primary",
                      style: {"margin":"0 8px"},
                      onClick: addHandle
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增 ")
                      ]),
                      _: 1
                    })), [
                      [_directive_btnPermission, 'Hospital:add']
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_table, {
      dataSource: _unref(data).dataSource,
      columns: columns,
      loading: _unref(data).loading,
      pagination: _unref(data).pagination,
      onChange: handleTableChange,
      expandRowByClick: true,
      scroll: { y:400},
      size: "small"
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'shortName')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(record.shortName), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'area')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(record.area), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'address')
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(record.address), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'tel')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(record.tel), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'type')
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(STATUS)('ClinicType').getDesc(record.businessData)), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'contact')
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(record.contact.name), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'position')
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(record.contactPosition), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (onEdit(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("修改")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_btnPermission, 'Hospital:update']
              ]),
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (onHospitalDetail(record.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("详情")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (onAddChildren(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("分支机构")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_btnPermission, 'Hospital:add']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (onScheduling(record.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("排班")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_btnPermission, 'Hospital:update']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (showRecharge(record.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("充值 ")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_btnPermission, 'Hospital:recharge']
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "loading", "pagination"]),
    (_unref(data).addHospitalvisible)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 1,
          visible: _unref(data).addHospitalvisible,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).addHospitalvisible) = $event)),
          title: "新建医院",
          width: "40%",
          onCancel: hideModal,
          confirmLoading: _unref(data).addHospitalloading,
          onOk: onSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(AddHospitalVue, {
              onOnCancel: onCancel,
              id: _unref(data).hospitalId,
              type: _unref(data).type,
              license: _unref(data).license,
              ref_key: "addHospitalRef",
              ref: addHospitalRef
            }, null, 8, ["id", "type", "license"])
          ]),
          _: 1
        }, 8, ["visible", "confirmLoading"]))
      : _createCommentVNode("", true),
    (_unref(data).rechargeVisible)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 2,
          visible: _unref(data).rechargeVisible,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_unref(data).rechargeVisible) = $event)),
          title: "充值",
          width: "40%",
          onCancel: rechargeCancel,
          confirmLoading: _unref(data).addHospitalloading,
          onOk: saveARecharge
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              ref_key: "rechargeRef",
              ref: rechargeRef,
              model: clinicRecharge,
              rules: rechargeRules
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  ref: "rechargeFee",
                  name: "rechargeFee",
                  label: "充值额度"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: clinicRecharge.rechargeFee,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((clinicRecharge.rechargeFee) = $event)),
                      min: 0,
                      step: 0.01,
                      precision: 2,
                      style: {"width":"320px"}
                    }, null, 8, ["value", "step"])
                  ]),
                  _: 1
                }, 512),
                _createVNode(_component_a_form_item, {
                  ref: "rechargeFrequency",
                  name: "rechargeFrequency",
                  label: "拍照次数"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: clinicRecharge.rechargeFrequency,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((clinicRecharge.rechargeFrequency) = $event)),
                      min: 0,
                      step: 1,
                      style: {"width":"320px"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["visible", "confirmLoading"]))
      : _createCommentVNode("", true)
  ]))
}
}

})